// CORE IMPORTS
import { useEffect } from "react";
import { Box } from "@mui/material";

// COMPONENTS
import { LoadingSpinner } from "src/components/application/LoadingSpinner";

// REDUX
import { useAppDispatch } from "src/store/store";
import { GetTargetOrderSummaryApiArg } from "src/store/features/api/generated";
import api from "src/store/features/api";

// UTILS
import { formatCurrency } from "src/utils/helpers/PriceAndUnitsHelpers";
import { dynamicUnitFormatter } from "src/utils/helpers/PriceAndUnitsHelpers";

// AMPLITUDE
import { useTargetStateV2, toggleSummaryView } from "src/store/features/TargetOrdersV2.slice";
import TradeConfirmationModal from "../../components/TradeConfirmationModal";

const TargetOrderSummery = () => {
  //------------------------STATE-------------------

  //------------------------STYLES-------------------
  const dispatch = useAppDispatch();
  const [getTargetSummery, { data, isLoading: isSummaryLoading, error: summeryError }] =
    api.useGetTargetOrderSummaryMutation();

  const { sellAssetSide, buyAssetSide, orderType, targetPrice } = useTargetStateV2();

  //------------------------HOOKS-------------------

  //------------------------Effects-------------------
  const handleBack = () => {
    dispatch(toggleSummaryView());
  };

  useEffect(() => {
    if (summeryError) {
      console.error(`Error occurred Target Orders Summery:`);
    }
  }, [summeryError]);

  useEffect(() => {
    if (orderType === "Buy") {
      const buyReqBody: GetTargetOrderSummaryApiArg = {
        targetOrderSummaryDto: {
          buy: {
            targetPrice: targetPrice,
            units: Number(buyAssetSide.units),
            code: buyAssetSide.code,
          },
          sell: { code: sellAssetSide.code },
        },
      };
      getTargetSummery(buyReqBody).catch((error) => {
        dispatch(toggleSummaryView());
      });
    } else {
      const sellReqBody: GetTargetOrderSummaryApiArg = {
        targetOrderSummaryDto: {
          buy: { code: buyAssetSide.code },
          sell: {
            targetPrice: targetPrice,
            units: Number(sellAssetSide.units),
            code: sellAssetSide.code,
          },
        },
      };
      getTargetSummery(sellReqBody).catch((error) => {
        dispatch(toggleSummaryView());
      });
    }
  }, []);

  // ----------------------- Handlers -----------------------------

  if (isSummaryLoading)
    return (
      <Box display="flex" height="500px" alignItems="center" justifyContent="center">
        <LoadingSpinner size={60} />
      </Box>
    );

  return (
    <>
      {data && (
        <TradeConfirmationModal
          tradeType="target"
          open={!!data}
          sellUnits={orderType === "Sell" ? String(data?.sell.units) : String(data?.buy.units)}
          sellCode={
            orderType === "Sell" ? data.sell.currencyConfig.code : data.buy.currencyConfig.code
          }
          buyUnits={orderType === "Sell" ? String(data?.buy.units) : String(data?.sell.units)}
          buyCode={
            orderType === "Sell" ? data.buy.currencyConfig.code : data.sell.currencyConfig.code
          }
          fee={data?.fee.amount}
          remainingUnits={
            orderType === "Sell"
              ? dynamicUnitFormatter(data?.remainingUnits, 0)
              : formatCurrency(data?.remainingUnits, data?.quoteCurrencyConfig.code)
          }
          priceData={String(targetPrice)}
          onClose={handleBack}
        />
      )}
    </>
  );
};

export default TargetOrderSummery;
